import axiosInstance from '../axios/axios-instance';
import { getAyetClientHintsHeaders } from '../client-hints/client-hints-context';
import { SignedTileDto } from 'shared/dto/project/signed-tile.dto';
import { INVITE_NOTIFICATIONS_UPDATED_EVENT } from 'src/constants/invite-notifications';

export const recommendationEngine = {
  /**
   * Fetches prioritized projects from the backend.
   * @returns Array of signed tile DTOs representing the prioritized projects
   */
  async fetchPrioritizedProjects(): Promise<SignedTileDto[]> {
    const headers = await getAyetClientHintsHeaders();
    const response = await axiosInstance.get<SignedTileDto[]>('/recommendation-engine/prioritized-projects', {
      headers,
    });
    window.dispatchEvent(new Event(INVITE_NOTIFICATIONS_UPDATED_EVENT));
    return response.data;
  },
};
